import videojs, { VideoJsPlayer } from 'video.js';

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

export interface SearchBoxPlayer {
    seek: (position: number) => void;
    getCurrentTime: () => number;
    seeking: () => boolean;
    pause: () => void;
    play: () => void;
}

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

export class VideoPlayerSearchApi implements SearchBoxPlayer {
    private api: VideoJsPlayer;
    private playerId: string = null;

    constructor(playerId: string) {
        if (typeof playerId == "string") {
            this.playerId = playerId;
        }
        else {
            console.error("VideoPlayerSearchApi: Invalid PlayerId");
        }
    }

    private getPlayer(): VideoJsPlayer {
        if (this.api == null && this.playerId != null) {
            this.api = videojs(this.playerId);
        }
        return this.api;
    }

    seek(position: number) {
        const api = this.getPlayer();
        if (api) api.currentTime(Math.ceil(position));
    }

    getCurrentTime(): number {
        const api = this.getPlayer();
        return api ? api.currentTime() : 0;
    }

    seeking(): boolean {
        const api = this.getPlayer();
        return api ? api.seeking() : false;
    }

    pause(): void {
        const api = this.getPlayer();
        api?.pause();
    }

    play(): void {
        const api = this.getPlayer();
        api?.play();
    }
}

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

export class YoutubePlayerSearchApi implements SearchBoxPlayer {
    private api: any;

    constructor(api: string | object) {
        if (typeof api === "string")
            this.api = window["YT"].get(api);
        else
            this.api = api;
    }

    seek(position: number) {
        // Posiciona
        try {
            if (this.api) {
                this.api.seekTo(Math.ceil(position));
            }
        }
        catch {
            console.log("Youtube api not ready.");
        };
    }

    getCurrentTime(): number {
        try {
            if (this.api) {
                return this.api.getCurrentTime();
            }
        }
        catch {
            console.log("Youtube api not ready.");
        };
        return 0;
    }

    seeking(): boolean {
        return false;
    }

    pause(): void {
        try {
            if (this.api) {
                return this.api.pauseVideo();
            }
        }
        catch{
            console.log("Youtube api not ready.");
        }
    }

    play(): void {
        try {
            if (this.api) {
                return this.api.play();
            }
        }
        catch{
            console.log("Youtube api not ready.");
        }
    }
}